import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { wwwLinks, wwwRoutes } from "../../../../variables/wwwRoutes";
import { useLocation } from "react-router-dom";
import { useMobile } from "common-frontend-components";
import { NavButton } from "./NavButton";
export const ProductsButton = () => {
    const location = useLocation();
    const isMobile = useMobile();
    if (isMobile)
        return _jsx(_Fragment, {}, void 0);
    return (_jsx(NavButton, { on: location.pathname === wwwRoutes.products, href: wwwRoutes.products, link: wwwLinks.products, children: "Store" }, void 0));
};
//# sourceMappingURL=ProductsButton.js.map